module.exports = __webpack_public_path__ + "img/pen-swirl.1a7f62c5.svg";